import { TUNING_MARKERS } from './lib/synth';

export interface SliderPresetPoint { value: number; label: string }
const tuningTableRows = TUNING_MARKERS
  .slice().sort((a, b) => a.fifth - b.fifth)
  .map(m => `<tr><td><strong>${m.fifth % 1 === 0 ? m.fifth : `~${String(m.fifth)}`}¢</strong></td><td>${m.description}</td></tr>`)
  .join('\n');
const SRC = 'https://github.com/zitongcharliedeng/gridinstruments/blob/main/literate';
export const srcLink = (file: string, label = 'Source'): string =>
  `<p style="margin-top:16px;padding-top:8px;border-top:1px solid #222;font-size:10px;"><a href="${SRC}/${file}" target="_blank" rel="noopener" style="color:var(--dim);">📄 ${label}</a></p>`;
export { tuningTableRows };
